import { Annotation } from '@cognite/unified-file-viewer';
import { ActiveWorkStep } from 'types';

export const shouldRenderStepBox = (
  annotation: Annotation,
  active: ActiveWorkStep,
  showWorkSteps?: boolean
): boolean => {
  if (!showWorkSteps || !active.workStep) return true;

  const { stepItem } = active.workStep;
  const stepItemAnnotationId = stepItem?.annotation?.id;
  const oldAnnotationId =
    annotation.metadata?.annotation?.data?.oldAnnotationId;

  return (
    (!!oldAnnotationId &&
      stepItemAnnotationId === parseInt(oldAnnotationId, 10)) ||
    stepItemAnnotationId === parseInt(annotation.id, 10) ||
    active.editable ||
    (!stepItemAnnotationId &&
      !stepItem?.relativeRef?.annotation?.id &&
      !stepItem?.line?.annotation?.id)
  );
};
